import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  increment,
} from "firebase/firestore";
import { getUserId } from "./utils";

const K_FACTOR = 32;

export const updateEloRatings = async (winnerId, loserId, db) => {
  const winnerRef = doc(db, "videos", winnerId);
  const loserRef = doc(db, "videos", loserId);

  const winnerSnap = await getDoc(winnerRef);
  const loserSnap = await getDoc(loserRef);

  if (!winnerSnap.exists() || !loserSnap.exists()) {
    console.error("One or both videos not found in the database.");
    return;
  }

  const winnerData = winnerSnap.data();
  const loserData = loserSnap.data();

  const winnerElo = winnerData.elo || 1000;
  const loserElo = loserData.elo || 1000;

  const expectedWinner = 1 / (1 + Math.pow(10, (loserElo - winnerElo) / 400));
  const expectedLoser = 1 - expectedWinner;

  const newWinnerElo = Math.round(winnerElo + K_FACTOR * (1 - expectedWinner));
  const newLoserElo = Math.round(loserElo + K_FACTOR * (0 - expectedLoser));

  await updateDoc(winnerRef, {
    elo: newWinnerElo,
    numVotesFor: (winnerData.numVotesFor || 0) + 1,
  });

  await updateDoc(loserRef, {
    elo: newLoserElo,
    numVotesAgainst: (loserData.numVotesAgainst || 0) + 1,
  });

  const userId = getUserId();
  const userRef = doc(db, "voteCounts", userId);
  const userSnap = await getDoc(userRef);

  if (userSnap.exists()) {
    await updateDoc(userRef, { count: userSnap.data().count + 1 });
  } else {
    await setDoc(userRef, { count: 1 });
  }

  const today = new Date().toISOString().split("T")[0];
  const dailyVoteRef = doc(db, "dailyVotes", today);

  try {
    const dailyVoteSnap = await getDoc(dailyVoteRef);
    if (dailyVoteSnap.exists()) {
      await updateDoc(dailyVoteRef, { count: increment(1) });
    } else {
      await setDoc(dailyVoteRef, { count: 1, date: today });
    }
  } catch (error) {
    console.error("Error updating daily vote count:", error);
  }

  return { newWinnerElo, newLoserElo };
};

export const pickProximityPair = (videos) => {
  if (videos.length < 2) return [null, null];

  const sorted = [...videos].sort(
    (a, b) => (a.elo || 1000) - (b.elo || 1000)
  );

  const leftIndex = Math.floor(Math.random() * sorted.length);
  const proximityFactor = 0.2;
  const rangeSize = Math.max(3, Math.round(sorted.length * proximityFactor));
  const lowerBound = Math.max(0, leftIndex - rangeSize);
  const upperBound = Math.min(sorted.length - 1, leftIndex + rangeSize);

  let rightIndex;
  do {
    rightIndex =
      lowerBound + Math.floor(Math.random() * (upperBound - lowerBound + 1));
  } while (rightIndex === leftIndex);

  return [sorted[leftIndex], sorted[rightIndex]];
};
